export const conditieMixin = {
  data() {
    return {
      condities: {
        default : { color : "0067cf", class: 'primary' },
        0 : { color: 'white', class: 'light' },
        1 : { color: '#00FF00', class: 'bg-success' }, // groen
        2 : { color: '#99FF00', class: 'bg-teal' }, // licht groen
        3 : { color: '#FFCC00', class: 'bg-yellow' }, // geel
        4 : { color: '#FF9900', class: 'bg-orange' }, // oranje
        5 : { color: '#FF0000',  class: 'bg-pink'}, // rood
        6 : { color: '#990000', class: 'bg-danger' }, // donkerrood
        7 : { color: '#FF0000' },
        8 : { color: '#FF0000' },
      },
      belangOptions: [
        { text: "Geen", value: null },
        { text: "Gering", value: 1 },
        { text: "Serieus", value: 2 },
        { text: "Ernstig", value: 3 }
      ],
      intensiteitOptions: [
        { text: "Geen", value: null },
        { text: "Laag", value: 1 },
        { text: "Gemiddeld", value: 2 },
        { text: "Hoog", value: 3 }
      ],
      omvangOptions: [
        { text: "Geen", value: null },
        { text: "<2%", value: 1 },
        { text: "2% tot 10%", value: 2 },
        { text: "10% tot 30%", value: 3 },
        { text: "30% tot 70%", value: 4 },
        { text: "70%>", value: 5 }
      ]
    };
  },
  methods: {
    getConditieClass(conditie) {
      if (this.condities[conditie]) return  this.condities[conditie].class;
      return this.condities.default.class
     },
    getConditieScore(belang,intensiteit,omvang) {
      if (belang == 0 || !belang) return -2;
      if (intensiteit == 0 || !intensiteit) return -2;
      if (omvang == 0 || !omvang) return -2;
      return Math.max(
        belang + intensiteit + omvang - 5,
        1
      );
    },
    getConditieGebrek(gebrek) {
      return this.getConditieScore(gebrek.belang,gebrek.intensiteit,gebrek.omvang);
    },
    getVeroudering(item) {
      if (isNaN(item.repeater.start)) return -2; 
      var leeftijd = new Date().getFullYear() - item.repeater.start;
      if (item.repeater.eind == null) return -2; 
      return this.getConditie(leeftijd,item.repeater.eind);
    },
    getConditie(leeftijd, levensduur) {
      var verloop = leeftijd/levensduur;
      switch (true) {
        case (isNaN(verloop)) : return -2
        case (verloop < 0.5) : return 1
        case (verloop < 0.75) : return 2
        case (verloop < 0.875) : return 3
        case (verloop < 0.9375) : return 4
        case (verloop < 0.9584) : return 5
        default : return 6
      }
    },
    
  }
};
